import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import * as App from 'modules/app/App';

// Main
import Profile from 'areas/main/profile/Profile';
import Impersonation from 'areas/main/impersonation/Impersonation';
import Dashboard from 'areas/main/dashboard/Dashboard';
import Search from 'areas/main/search/Search';
import Recent from 'areas/main/recent/Recent';
import Notifications from 'areas/main/notifications/Notifications';

// Admin
import AppConfig from 'areas/admin/appConfig/AppConfig';
import BatchProcesses from 'areas/admin/batchProcesses/BatchProcesses';
import AccountSetup from 'areas/admin/accountSetup/AccountSetup';
import TooltipManagerSetup from 'areas/admin/tooltipManagerSetup/TooltipManagerSetup';
import EmailingLog from 'areas/admin/emailingLog/EmailingLog';
import EmailTemplateSetup from 'areas/admin/emailingTemplateSetup/EmailTemplateSetup';
import ReportManagement from 'areas/admin/reportManagement/ReportManagement';
import UserSetup from 'areas/admin/userSetup/UserSetup';
import RoleSetup from 'areas/admin/roleSetup/RoleSetup';
import SponsorSetup from 'areas/admin/sponsorSetup/SponsorSetup';
import AdminSponsorDashboard from 'areas/main/dashboard/adminSponsorDashboard/AdminSponsorDashboard';
import NewsSetup from 'areas/admin/newsSetup/NewsSetup';
import TermsAndConditionsSetup from 'areas/admin/termsAndConditionsSetup/TermsAndConditionsSetup';
import NotificationSetup from 'areas/admin/notificationSetup/NotificationSetup';
import HelpSetup from 'areas/admin/helpSetup/HelpSetup';
import AuditReview from 'areas/admin/auditReview/AuditReview';
import Console from 'areas/admin/console/Console';
import CertificationSetup from 'areas/admin/certification/certificationInfo/CertificationSetup';
import SearchQueue from 'areas/admin/certification/Search';
import SupplierList from 'areas/admin/supplierList/SupplierList';
import NaicsCodeSetup from 'areas/admin/naicsCodeSetup/NaicsCodeSetup';
import DenialCodeSetup from 'areas/admin/denialCodeSetup/DenialCodeSetup';
import SiteReview from 'areas/admin/certification/siteReview/SiteReview';
import AdminConnectToVOB from 'areas/admin/connectToVOB/ConnectToVOB';
import AdminDD214Setup from 'areas/admin/dd214Setup/DD214Setup';
import PaypalInvoiceSetup from 'areas/admin/paypalInvoiceSetup/PaypalInvoiceSetup';
import AdminDiscountCodeSetup from 'areas/admin/discountCodeSetup/DiscountCodeSetup';
import AdminDiscountCodeDashboard from 'areas/main/dashboard/adminDiscountCodeDashboard/AdminDiscountCodeDashboard';
import AdminSponsorTypeSetup from 'areas/admin/sponsorTypeSetup/SponsorTypeSetup';

// Demo
import PrimeroDemo from 'areas/demo/primeroDemo/PrimeroDemo';

// Errors
import NotFoundError from 'areas/shared/errors/notFound/NotFound';

// Certification
import PreQualification from 'areas/certification/preQualification/PreQualification';
import PreQualificationPayment from 'areas/certification/preQualification/PreQualificationPayment';
import PreQualificationPaymentAccepted from 'areas/certification/preQualification/PreQualificationPaymentAccepted';
import Certification from 'areas/certification/Certification';
import OneSheetRenewal from 'areas/certification/oneSheet/OneSheetRenewal';

// Company Management
import ManageCompanySetup from 'areas/companyManagement/manageCompany/ManageCompanySetup';
import CertifyBusiness from 'areas/companyManagement/certifyBusiness/CertifyBusiness';
import ConnectToVOB from 'areas/companyManagement/connectToVOB/ConnectToVOB';
import ConnectToSponsors from 'areas/companyManagement/connectToSponsors/ConnectToSponsors';

// Sponsor
import SponsorConnectToVOB from 'areas/sponsor/connectToVOB/ConnectToVOB';
import ManageSponsorSetup from 'areas/sponsor/sponsorSetup/SponsorSetup';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      App.isAuthenticated() === true ? (
        <Component {...props} />
      ) : (
          <Redirect to='/login' />
        )
    }
  />
);

class PrivateRoutes extends React.Component {
  render() {
    return (
      <Switch>
        <PrivateRoute exact path='/' component={Dashboard} />
        <PrivateRoute path='/search' component={Search} />
        <PrivateRoute path='/recent' component={Recent} />
        <PrivateRoute path='/notifications' component={Notifications} />
        <PrivateRoute
          path='/accounts/impersonation'
          component={Impersonation}
        />
        <PrivateRoute path='/accounts/profile' component={Profile} />
        <PrivateRoute path='/admin/appConfig' component={AppConfig} />
        <PrivateRoute path='/admin/accountSetup' component={AccountSetup} />
        <PrivateRoute path='/admin/roleSetup' component={RoleSetup} />
        <PrivateRoute path='/admin/userSetup' component={UserSetup} />
        <PrivateRoute path='/admin/tooltipManagerSetup' component={TooltipManagerSetup} />
        <PrivateRoute path='/admin/emailingLog' component={EmailingLog} />
        <PrivateRoute path='/admin/emailingTemplateSetup' component={EmailTemplateSetup} />
        <PrivateRoute path='/admin/reportManagement' component={ReportManagement} />
        <PrivateRoute path='/admin/roleSetup' component={RoleSetup} />
        <PrivateRoute path='/admin/sponsorSetup' component={SponsorSetup} />
		<PrivateRoute path='/admin/sponsorDashboard' component={AdminSponsorDashboard} />
        <PrivateRoute path='/admin/dd214Setup' component={AdminDD214Setup} />
        <PrivateRoute path='/admin/veteranDD214/:certificationKey' component={AdminDD214Setup} />
        <PrivateRoute path='/admin/newsSetup' component={NewsSetup} />
        <PrivateRoute path='/admin/termsAndConditionsSetup' component={TermsAndConditionsSetup} />
        <PrivateRoute path='/admin/notificationSetup' component={NotificationSetup} />
        <PrivateRoute path='/admin/helpSetup' component={HelpSetup} />
        <PrivateRoute path='/admin/auditReview' component={AuditReview} />
        <PrivateRoute path='/admin/console' component={Console} />
        <PrivateRoute path='/admin/certification' component={CertificationSetup} />
        <PrivateRoute path='/admin/searchQueue' component={SearchQueue} />
        <PrivateRoute path='/admin/siteReview' component={SiteReview} />
        <PrivateRoute path='/admin/supplierList' component={SupplierList} />
        <PrivateRoute path='/admin/naicsCodeSetup' component={NaicsCodeSetup} />
        <PrivateRoute path='/admin/denialCodeSetup' component={DenialCodeSetup} />
        <PrivateRoute path='/admin/connectToVOB' component={AdminConnectToVOB} />
        <PrivateRoute path='/demo/primeroDemo' component={PrimeroDemo} />
        <PrivateRoute path='/admin/batchProcesses' component={BatchProcesses} />
        <PrivateRoute path='/admin/paypalInvoiceSetup' component={PaypalInvoiceSetup} />
		<PrivateRoute path='/admin/discountCodeSetup' component={AdminDiscountCodeSetup} />
		<PrivateRoute path='/admin/discountCodeDashboard' component={AdminDiscountCodeDashboard} />
		<PrivateRoute path='/admin/sponsorTypeSetup' component={AdminSponsorTypeSetup} />
        
        <PrivateRoute path='/certification/preQualification/:vobKey' component={PreQualification} />
        <PrivateRoute path='/certification/addPreQualification/:vobFeinKey?/:vobNameKey?' component={PreQualification} />
        <PrivateRoute path='/certification/preQualificationPayment/:vobKey' component={PreQualificationPayment} />
        <PrivateRoute path='/certification/preQualificationPaymentAccepted/:vobKey' component={PreQualificationPaymentAccepted} />

        <PrivateRoute path='/certification/certification/:stepCode/:certificationKey' component={Certification} />
        <PrivateRoute path='/certification/renewalOneSheet/:certificationKey' component={OneSheetRenewal} />
        <PrivateRoute path='/ManageCompany' component={ManageCompanySetup} />
        <PrivateRoute path='/CertifyBusiness' component={CertifyBusiness} />
        <PrivateRoute path='/ConnectToVOB' component={ConnectToVOB} />
        <PrivateRoute path='/ConnectToSponsors' component={ConnectToSponsors} />        

        <PrivateRoute path='/sponsor/ConnectToVOB' component={SponsorConnectToVOB} />
        <PrivateRoute path='/sponsor/sponsorSetup' component={ManageSponsorSetup} />
        
        <PrivateRoute path='*' component={NotFoundError} />
      </Switch>
    );
  }
}

export default PrivateRoutes;



// WEBPACK FOOTER //
// ./src/layouts/main/routes/Routes.js